<template>
  <div>
	  <button @click="addrow">新增行</button>
	  <button @click="editrow">编辑行</button><el-input type="text" v-model="rowindex"></el-input>
	  <testgridexpand ref="gridexpand" :tablemain="tableData" 
		editcell="0"
		:columns="columns"
		:rowclassname="setrowclass"
		:gridheight="gridheight"
		@getExpandsRow="getExpandsInfo"
		:rowkey="rowkey"
		@callbackFun="callbackFun"
		:maincounttype="type"
		@gridhandle="gridhandle"
	  >
		  
	  </testgridexpand>
	 <!-- <pl-table :data="tableData" ref="testtable" :key="timestamp" row-key="id" :expand-row-keys="expands">
	    <pl-table-column label="姓名">
	      <template  slot-scope="scope">
	        <el-input v-model="scope.row.name"></el-input>
	      </template>
	    </pl-table-column>
	    <pl-table-column label="年龄">
	      <template  slot-scope="scope">
	        <el-input v-model="scope.row.age" ></el-input>
	      </template>
	    </pl-table-column>
		<pl-table-column width="50">
			<template slot-scope="scope">
				<div v-if="scope.row.showexpand" 
				 @click="getExpandsInfo(scope.$index,scope.row,!scope.row.expand)">
					<i :class="['el-icon', scope.row.expand? 'el-icon-arrow-down' : 'el-icon-arrow-right']"></i>
				</div>
			</template>
		</pl-table-column>
	    <pl-table-column type="expand" width="1">
	      <template slot-scope="scope">
			  <testgrid ref="testgrid" :expandlist="scope.row.expandlist" :rowindex="scope.$index" @controlcentercallback="controlcentercallback"></testgrid>
	      </template>
	    </pl-table-column>
	  </pl-table> -->
  </div>
</template>

<script>
import Utils from '../../lib/util.js';	
import testgridexpand from '../../components/table/tablegrid_expand2.vue';
export default {
  components: {
  	testgridexpand
  },
  data() {
	return {
		rowkey:'id',
		istop:false,
		isexpand:false,
		loading:false,
		packagelist:[],
		columns:[
				{ field: 'id', title: '编号', type: 'text', width: '30',isedit:false, sortable: false },
				{ field: 'name', title: '姓名', type: 'text', width: '120',isedit:false, sortable: false },
				{ field: 'age', title: '年龄', type: 'text', width: '120',isedit:false, sortable: false },
				{
					field: '',
					title: '操作',
					type: 'template',
					template: [
						{ type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
						{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
					],
					width: 120,
					sortable: false,
					evttype: 'click',
					colshow: '1',
					event: ''
				}
			],
		gridheight:'600px',
		pageindex:0,
		handle: {
			field: '',
			title: '操作',
			type: 'template',
			template: [
				{ type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
				{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
			],
			width: 120,
			sortable: false,
			evttype: 'click',
			colshow: '1',
			event: ''
		},
		tableData:[
			
		],
		rowindex:0,
		timestamp:"11",
		expands:[],
		type:'采购入库'
	}
  },
  mounted() {
	  
  	this.init();
  },
  methods: {
	setrowclass({row, rowIndex}){
		//debugger
		row.index=rowIndex;
	},
	init(){
		//加载首页配置信息
		
		 var that=this;
		setTimeout(function(){
			that.loaddata();
		},1000);
		//that.loaddata();
	},
	loaddata(){
		this.tableData=[{id:1, name:'张三',age:10,haschild:'0',expand:false,item:{},urlparam:{}},
			{id:2,name:'李四1',age:20,haschild:'1',expand:false,item:{},urlparam:{}},{id:3, name:'张三5',age:10,haschild:'0',expand:false,item:{},urlparam:{}},
			{id:4,name:'李四2',age:21,haschild:'1',expand:false,item:{},urlparam:{}},{id:5, name:'张三6',age:10,haschild:'0',expand:false,item:{},urlparam:{}},
			{id:6,name:'李四3',age:22,haschild:'1',expand:false,item:{},urlparam:{}},{id:7, name:'张三7',age:10,haschild:'0',expand:false,item:{},urlparam:{}},
			{id:8,name:'李四4',age:23,haschild:'1',expand:false,item:{},urlparam:{}}];
		//debugger	
	},
	addrow(){
		this.tableData.push({
			id:this.tableData.length+1, 
			name:'张三'+(this.tableData.length+1).toString(),
			age:10,
			haschild:'1',
			expand:false,
			item:{},urlparam:{}
			});
		// this.packagelist.push({
		// 	r_name:'管理员'+(this.packagelist.length+1).toString(),
		// 	r_id:(this.packagelist.length+1).toString(),
		// 	expand:false,
		// 	showexpand:true,
		// 	item:{},
		// 	urlparam:{}
		// });
	},
	editrow(){
		this.tableData.splice(this.rowindex,1,{
			id:this.tableData.length+1,
			name:'张三'+(this.tableData.length+1).toString(),
			age:10,
			haschild:'0',
			expand:false,
			item:{},
			urlparam:{}
		});
	},
	callbackFun(e){
		debugger
		var sumnum=0;
		e.list.forEach(b=>{
			if(b.num!="")
				sumnum=sumnum+Number(b.num);
		});
		this.tableData[e.gridrowindex].age=sumnum;
		this.$refs.gridexpand.SetTableList({gridindex:e.gridrowindex,row:this.tableData[e.gridrowindex]});
	},
	//获取详情
	getExpandsInfo(e){
		//debugger
		this.tableData[e.index].expand=e.expand;
		this.tableData[e.index].item={
			l_pagetype:'tablegridcontrol'
		}
		this.tableData[e.index].urlparam={
			"id":e.index,
			'gridrowindex':e.index,
			"syscol":"p_pkval,p_airwaybill,p_bagid,p_remark,sendername,expresscom,expressid,sendtype,cnameall,cname,ename,spec,cno,unit,packagenum,section,unit1,num1,unitcode,unit2,num,cargourl,outprice,price,p_sign,models,taxprice,material,p_isbattery",
			"type":"采购入库_扩展",
			};
		this.$refs.gridexpand.SetExpandSonList({rowindex:e.index,expand:e.expand,
		item:this.tableData[e.index].item,urlparam:this.tableData[e.index].urlparam});
	},
	gridhandle(e){
		debugger
	}
  }
}
</script>
<style lang="scss" scoped>
* {
  margin: 0;
}
.home {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top:30px;
  .top {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;

    .img {
      width: 193px;
	  height:auto;
    }

    .li {
      margin: 0 20px;
      display: block;
	  font-size:16px;
	  letter-spacing:1px;
    }
  }
  .middle {
    height: 70vh;
    position: relative;
    .login {
      border-radius: 10px;
      z-index: 999;
      width: 280px;
      min-height: 310px;
      background-color:#ffffff;
      position: absolute;
      top: 10%;
      right: 10%;
	  border-color:#a4a5a4;
      padding: 40px 20px 0 20px;
    }
	.bannerimg{
		width:100%;
		height:auto;
		min-height:430px;
	}
  }
  .foot {
	width:100%;
	position:fixed;
	bottom:20px;
    // height: 20vh;
    // margin-top: 20px;
    // border: 1px solid red;
  }
  /deep/ .el-input__inner {
       border-radius:20px;
	   margin-top:8px;
	}
}

.fontClass{
	font-size:18px;
	letter-spacing:10px;
}
.fontClassbtn{
	font-size:14px;
	letter-spacing:10px;
}
.icon {
  color: #00c89f;
  font-size: 40px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

::v-deep {
  .el-select {
    width: 100%;
  }
}
</style>
